import { render, staticRenderFns } from "./specialPayChannelOrder.vue?vue&type=template&id=629972d2&scoped=true"
import script from "./specialPayChannelOrder.vue?vue&type=script&lang=js"
export * from "./specialPayChannelOrder.vue?vue&type=script&lang=js"
import style0 from "./specialPayChannelOrder.vue?vue&type=style&index=0&id=629972d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629972d2",
  null
  
)

export default component.exports